import Link from "next/link"
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md"
import Container from "../base/container"
import styles from "./breadcrumb.module.scss"
import Router from "next/router"

const Breadcrumb = (props) => {
  const { className = "", backToSearchLink, breadcrumbs = [], currentLinkText } = props

  return (
    <div className={`${className} ${styles.listingBreadcrumb}`}>
      <Container>
        <div className={styles.breadcrumbList}>
          {backToSearchLink ? (
            <div className={styles.back}>
              <Link href={`${backToSearchLink}`} prefetch={false} replace={true}>
                <a className={styles.link}>
                  <MdKeyboardArrowLeft />
                  Back to Search
                </a>
              </Link>
            </div>
          ) : null}

          <div className={styles.item}>
            <Link href="/" prefetch={false}>
              <a className={styles.link} href="/">
                Lamudi.pk
              </a>
            </Link>
            <MdKeyboardArrowRight />
          </div>
          {/* TODO: location name only */}
          {breadcrumbs.map((item) => {
            return (
              <div className={styles.item} key={item.title}>
                <Link href={item.slug} prefetch={false}>
                  <a className={styles.link}>{item.title}</a>
                </Link>
                <MdKeyboardArrowRight />
              </div>
            )
          })}
          <div className={styles.item}>
            <span className={styles.disable}>{currentLinkText}</span>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Breadcrumb
